import { ref, onMounted } from 'vue'
import type { Ref } from 'vue'

const _cleanups: Function[] = []
const _cleanup = () => {
  setTimeout(() => {
    _cleanups.forEach((fn) => fn())
    _cleanups.length = 0
  }, 0)
}

export const useOffline = () => {
  const isOnline = ref(true)
  const offlineAt: Ref<number | undefined> = ref(undefined)
  const onlineAt: Ref<number | undefined> = ref(undefined)

  // const _updateNetworkInformation = () => {
  //   if (!navigator) {
  //     return
  //   }

  //   isOnline.value = navigator.onLine
  //   offlineAt.value = isOnline.value ? undefined : Date.now()
  //   onlineAt.value = isOnline.value ? Date.now() : undefined
  //   // const connection = navigator && 'connection' in navigator
  //   // if (connection) {
  //   //   downlink.value = connection.downlink
  //   //   downlinkMax.value = connection.downlinkMax
  //   //   effectiveType.value = connection.effectiveType
  //   //   rtt.value = connection.rtt
  //   //   saveData.value = connection.saveData
  //   //   type.value = connection.type
  //   // }
  // }

  const _updateOnlineState = (value: boolean) => {
    isOnline.value = value
    offlineAt.value = isOnline.value ? undefined : Date.now()
    onlineAt.value = isOnline.value ? Date.now() : undefined
  }

  const _onOffline = () => {
    _updateOnlineState(false)
    document.body.classList.remove('offline')
    document.body.classList.add('offline')
  }
  const _onOnline = () => {
    _updateOnlineState(true)
    document.body.classList.remove('offline')
  }

  onMounted(() => {
    if (import.meta.browser && _cleanups.length === 0) {
      // @ts-ignore
      if (window && window.addEventListener) {
        window.addEventListener('offline', _onOffline, false)
        window.addEventListener('online', _onOnline, false)

        _cleanups.push(
          () => window.removeEventListener('offline', _onOffline, false),
          () => window.removeEventListener('online', _onOnline, false),
        )
      } else {
        const body: any = document.body
        if (!body.onoffline) {
          body.onoffline = _onOffline
        }
        if (!body.onoffline) {
          body.ononline = _onOnline
        }
        body.addEventListener('onoffline', _onOffline, false)
        body.addEventListener('ononline', _onOnline, false)
        _cleanups.push(() => {
          body.removeEventListener('onoffline', _onOffline, false)
          body.removeEventListener('onOnline', _onOnline, false)
          delete body.onoffline
          delete body.ononline
          body.onoffline = null
          body.ononline = null
        })
      }
    }
  })

  onUnmounted(() => {
    _cleanup()
  })

  return {
    isOnline,
    offlineAt,
    onlineAt,
  }
}
